module.exports = __webpack_public_path__ + "img/in-or.912a446c.svg";